import { createRoot } from "react-dom/client";
import App from "./App.tsx";

// Auto-reload if a dynamic import fails (usually means a new deployment happened and cached chunks are missing)
window.addEventListener('vite:preloadError', (event) => {
  console.warn('Vite preload error, reloading page...', event);
  window.location.reload();
});

window.addEventListener('error', (e) => {
  if (e.message?.includes('Failed to fetch dynamically imported module')) {
    console.warn('Dynamic import failed, reloading page...', e);
    window.location.reload();
  }
});
import { HelmetProvider } from "react-helmet-async";
import { registerServiceWorker } from "./lib/service-worker-registration";

import "@fontsource/inter/300.css";
import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "@fontsource/inter/700.css";
import "@fontsource/dm-sans/400.css";
import "@fontsource/dm-sans/500.css";
import "@fontsource/dm-sans/700.css";
import "./index.css";
// Register service worker for PWA
registerServiceWorker();

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);